export const SET_TABLE_COLUMN_DATA = "SET_TABLE_COLUMN_DATA"

export const setTableColumnData = (columnData: any[],key:string) => {
    return {
        type: SET_TABLE_COLUMN_DATA,
        payload: columnData
    }
};